/* @flow */

import React, { Component } from 'react';
import { Segment, Form, Input, Grid, Button } from 'semantic-ui-react';

type Props = {
  folder: BucketFolder,
  onChange: (folder: BucketFolder) => void,
  isUpdating: boolean,
};

type State = {
  name: string,
};

class FolderForm extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      name: props.folder.name,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.folder !== this.props.folder) {
      this.setState({
        name: nextProps.folder.name,
      });
    }
  }

  onNameChange = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      this.setState({
        name: event.target.value,
      });
    }
  };

  onFormSubmit = event => {
    const { folder, onChange } = this.props;
    const { name } = this.state;

    event.preventDefault();

    if (name && name.length > 0) {
      onChange({
        ...folder,
        name,
      });
    }
  };

  render() {
    const { isUpdating } = this.props;
    const { name } = this.state;

    return (
      <Segment attached="top">
        <Form onSubmit={this.onFormSubmit}>
          <Grid>
            <Grid.Column width={12}>
              <Form.Field inline>
                <label>Nom</label>
                <Input
                  name="name"
                  value={name}
                  style={{ width: '91%' }}
                  onChange={this.onNameChange}
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={4}>
              <Button
                loading={isUpdating}
                disabled={name.length === 0}
                type="submit"
                primary
                content="Enregistrer"
                icon="save"
                floated="right"
              />
            </Grid.Column>
          </Grid>
        </Form>
      </Segment>
    );
  }
}

export default FolderForm;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folder/components/FolderForm.js